(function(){
  var h=document.querySelector('header.top'); if(!h) return;
  var hero=document.getElementById('start');
  // próg = wysokość hero minus wysokość nagłówka; jeśli brak hero, przyklejaj od razu po 10px
  function prog(){ return hero ? Math.max(60, hero.offsetHeight - h.offsetHeight) : 10; }
  function onScroll(){
    if(window.scrollY > prog()){ h.classList.add('przyklejony'); }
    else{ h.classList.remove('przyklejony'); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();
})();